import { Button } from '@nextui-org/react'
import { ChartContainer } from '../components/chart/ChartContainer'
import { SelectTanksToBrowse } from '../components/selectSchools'
import { SelectProperties } from '../components/selectSchools/SelectProperties'
import useChartStore from '../store/chart/useChartStore'

export default function Chart() {
  const { selectedSchools, properties, setShowState, showState } = useChartStore((state) => ({
    selectedSchools: state.selectedSchools,
    properties: state.properties,
    setShowState: state.setShowState,
    showState: state.showState,
  }))

  return (
    <div className="p-4 md:p-[40px]">
      <div className="flex flex-col md:flex-row justify-between gap-4">
        <div>
          <h1 className="font-bold text-tdplindigo mb-6 md:mb-[40px] text-2xl md:text-[2rem]">
            Chart
          </h1>
        </div>
      </div>
      <div className="flex gap-2 justify-evenly overflow">
        <SelectTanksToBrowse />
      </div>
      <div className="flex flex-row items-center justify-end mt-4 gap-2">
        <SelectProperties />
        <Button
          isDisabled={!(selectedSchools.length > 0 && properties.length > 0)}
          size="sm"
          className="text-white bg-tdplplum"
          onPress={setShowState}
          style={{ marginLeft: 0 }}
        >
          Browse
        </Button>
      </div>
      <ChartContainer showState={showState} />
    </div>
  )
}
